import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../helper/axiosInstance";
import axiosInstanceWebPortal from "../helper/axiosInstanceWebPortal";
import { toast } from "react-toastify";
import Socket from "./socketConnect";
import { GetAllNotificationCustomerAsync, GetAllNotificationBusinessAsync, GetAllUnreadMsgAsync } from "./chatSlice"
import Swal from "sweetalert2";
import { forceLogout } from "../components/Utils/forceLogout";
const initialState = {
  userType: "UNREGISTERED",
  userDetails: "",
  loginLoading: false,
  verifyAdminLoading: false,
  sessionTokenAdmin: "",
  adminData: [],
  logoutData: [],
  CSVVerificationAccountType: "",
  specialLoginLoading: false,
  specialLoginFailed: "",
  resendEamilLoading: false,
  resendEmailData: [],
  resendEmailError: "",
  currentSideBarStatus: true,
  loading: false,
  showUnauthorizedModal: false,
  showSessiosAlert: false,
  uploadingTracker: 0,
  Idloading: false,
  AddressId: '',
  isOffline: false,
  isServerDown: false,
  VerifyCredentialsLoading: false,
  DeleteAccountLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state) => {
      state.loginLoading = true;
    },
    loginMasterSuccess: (state, action) => {
      // state.userType = action.payload.accountType;
      // state.userDetails = action.payload;
      state.loginLoading = false;
      state.specialLoginLoading = false;
    },
    loginAdminSuccess: (state, action) => {
      console.log("token", action.payload);
      state.sessionTokenAdmin = action?.payload;
      state.loginLoading = false;
    },
    verifyAdmin: (state) => {
      state.verifyAdminLoading = true;
    },
    verifyAdminSuccess: (state, action) => {
      state.userDetails = action.payload;
      state.adminData = action.payload;
      state.userType = action.payload.accountType;
      state.verifyAdminLoading = false;
    },
    verifyAdminFailed: (state) => {
      state.verifyAdminLoading = false;
    },

    loginAdminLocalSuccess: (state, action) => {
      state.userDetails = action.payload;
      state.loginLoading = false;
      state.userType = action.payload.accountType;
    },
    loginFailed: (state) => {
      state.loginLoading = false;
    },

    logout: (state) => {
      state.userType = "UNREGISTERED";
    },
    logoutSuccess: (state, action) => {
      state.logoutData = action.payload;
      sessionStorage.removeItem("userLoggedDetails");
      sessionStorage.removeItem("userLoggedToken");
      sessionStorage.clear();
      localStorage.clear();
      state.userType = "UNREGISTERED";
    },
    // logoutFailed: (state) => {
    //   // state.userType = "UNREGISTERED";
    // },
    emptyAuthState: (state) => {
      state.userType = "UNREGISTERED";
      state.userDetails = "";
      state.loginLoading = false;
      state.verifyAdminLoading = false;
      state.sessionTokenAdmin = "";
    },
    recognizeAccountType: (state, action) => {
      state.CSVVerificationAccountType = action.payload;
    },

    LoginSpecial: (state) => {
      state.specialLoginLoading = true;
    },
    LoginSpecialSuccess: (state, action) => {
      state.specialLoginLoading = false;
      state.adminData = action.payload;
    },
    LoginSpecialFailed: (state, action) => {
      state.specialLoginLoading = false;
      state.specialLoginFailed = action.payload;
    },

    ResendEmail: (state) => {
      state.resendEamilLoading = true;
    },
    ResendSuccessfully: (state, action) => {
      state.resendEamilLoading = false;
      state.resendEmailData = action.payload;
    },
    ResendError: (state, action) => {
      state.resendEamilLoading = false;
      state.resendEmailError = action.payload;
    },
    updateidebarStatus: (state, action) => {
      state.currentSideBarStatus = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = true;
    },
    refreshSuccess: (state, action) => {
      state.userDetails = action.payload;
      state.loading = false;
    },
    refreshFailed: (state) => {
      state.loading = false;
      state.error = "Failed to refresh token";
    },
    logoutFailed: (state) => {
      state.error = "Logout failed";
    },
    UpdateSessionAlert: (state, action) => {
      state.showUnauthorizedModal = action.payload;
      // if(action.payload===''){
      //   state.previousRoute = action.payload;
      // }
    },
    ToggleSessionAlert: (state, action) => {
      state.showSessiosAlert = action.payload;
    },
    UploadingProgress: (state, action) => {
      state.uploadingTracker = action.payload;
    },

    GetUniqueId: (state) => {
      state.Idloading = true;
    },
    GetUniqueIdSuccess: (state, action) => {
      state.Idloading = false;
      state.AddressId = action.payload;
    },
    GetUniqueIdFailed: (state) => {
      state.Idloading = false;
    },
     setOfflineStatus: (state, action) => {
      state.isOffline = action.payload;
    },
    setServerDown: (state, action) => {
      state.isServerDown = action.payload;
    },

    VerifyCredentials: (state) => {
      state.VerifyCredentialsLoading = true;
    },
    VerifyCredentialsSuccess: (state) => {
      state.VerifyCredentialsLoading = false;
    },
    VerifyCredentialsError: (state) => {
      state.VerifyCredentialsLoading = false;
    },

    DeleteAccount: (state) => {
      state.DeleteAccountLoading = true;
    },
    DeleteAccountSuccess: (state) => {
      state.DeleteAccountLoading = false;
    },
    DeleteAccountError: (state) => {
      state.DeleteAccountLoading = false;
    },

  },
});
// export const loginAsync = (data, remember) => async (dispatch) => {
//   dispatch(login());
//   try {
//     const response = await axiosInstance.post("/upload/userLogin", data);
//     if (response) {
//       if (response.data?.user?.accountType === "masteradmin") {
//         const userData = {
//           ...response?.data?.user,
//           remember,
//         };
//         dispatch(loginMasterSuccess(userData));
//         sessionStorage.setItem(
//           "userLoggedDetails",
//           JSON.stringify(response.data?.user)
//         );
//         sessionStorage.setItem(
//           "userLoggedToken",
//           JSON.stringify(response.data?.token)
//         );
//         return response?.data;
//       } else {
//         dispatch(loginAdminSuccess(response?.data?.sessionToken));
//         sessionStorage.setItem(
//           "userLoggedDetails",
//           JSON.stringify(response?.data?.user)
//         );
//         sessionStorage.setItem(
//           "userLoggedToken",
//           JSON.stringify(response.data?.token)
//         );
//         return response?.data;
//       }
//     }
//   } catch (error) {
//     dispatch(loginFailed());

//     toast.error(
//       error?.response?.data?.message
//         ? error.response.data.message
//         : "Login failed!!"
//     );
//     console.log(error, error?.response?.data.message);

//     return "error";
//   }
// };

export const GetIdAddress = (data) => async (dispatch) => {
  dispatch(GetUniqueId());
  try {
    const response = await axiosInstance.get("/AdminConroller/deployment-uuid");
    if (response?.status == 200) {
      dispatch(GetUniqueIdSuccess(response?.data?.deploymentUUID));
      return response?.data?.deploymentUUID;
    }
  } catch (error) {
    console.log('getting error', error)
    dispatch(GetUniqueIdFailed());
    return 'failed'
  }
};

export const loginAsync = (data) => async (dispatch) => {
  dispatch(login());
  try {
    const response = await axiosInstance.post("/upload/userLogin", data);
    if (response) {
      console.log('response from login', response);

      if (response?.data?.response?.accountType === "masteradmin") {
        dispatch(loginMasterSuccess());
        return response;
      } else {
        dispatch(loginAdminSuccess(response));
        // dispatch(GetAllNotificationCustomerAsync());
        // dispatch(GetAllNotificationBusinessAsync());
        return response;
      }
    }
  } catch (error) {
    dispatch(loginFailed());
    toast.error(
      error?.response?.data?.error
        ? error.response.data.error
        : "Login failed!!"
    );
    return error?.response;
  }
};
export const VerifyDeleteAccountCredentials = (data) => async (dispatch) => {
  dispatch(VerifyCredentials());
  try {
    const response = await axiosInstance.post("/upload/DeleteAccountVerifyCredentials", data);
    if (response) {
      console.log('response from send', response);
      dispatch(VerifyCredentialsSuccess());
      return response;
    }
  } catch (error) {
    console.log('error.......', error)
    dispatch(VerifyCredentialsError());
    toast.error(
      error?.response?.data?.message
        ? error.response.data.message
        : "OTP send failed!"
    );
    return error?.response;
  }
};

// SpecialAdminLogin----------

export const SpecialAdminLogin = (data, MaDetails) => async (dispatch) => {
  console.log('MaDetails,,,,', MaDetails)
  dispatch(LoginSpecial());
  try {
    const response = await axiosInstance.post(
      "/AdminConroller/specialAdminLogin",
      data
    );

    if (response) {
      console.log("API respp after admin", response);
      dispatch(GetAllNotificationCustomerAsync());
      dispatch(GetAllNotificationBusinessAsync());
      dispatch(GetAllUnreadMsgAsync());


      const token = response.headers["token"];
      const Refreshtoken = response.headers["refreshtoken"];
      await sessionStorage.clear();
      // sessionStorage.clear() above wipes loggedInIpAddress too — restore it
      // (from the same IP this very switch request was sent with) so the
      // return trip (admin -> master admin) can reuse it instead of doing a
      // fresh ipify lookup.
      if (data?.ipAddress) {
        sessionStorage.setItem("loggedInIpAddress", data.ipAddress);
      }
      await sessionStorage.setItem(
        "userLoggedDetails",
        JSON.stringify(response.data?.data)
      );
      await sessionStorage.setItem("MaUser", MaDetails);
      await sessionStorage.setItem("userLoggedToken", JSON.stringify(token));
      await sessionStorage.setItem("refreshToken", JSON.stringify(Refreshtoken));
      if (response?.data?.data?.accountType == "admin") {
        sessionStorage.setItem("IsMaLogin", "true");
      }
      dispatch(verifyAdminSuccess(response.data?.data));
      dispatch(LoginSpecialSuccess(response.data?.data));
      toast.success(
        response?.data?.data?.accountType !== "admin"
          ? "Login Back to master admin!!"
          : "Login as admin"
      );
    }
  } catch (error) {
    dispatch(LoginSpecialFailed(error));
    toast.error(
      error?.response?.data?.message
        ? error.response.data.message
        : "Login failed!!"
    );
    return "error";
  }
};

export const sessionStorageLoginAsync = (data) => async (dispatch) => {
  if (data) {
    if (data.accountType === "MASTERADMIN") {
      dispatch(loginMasterSuccess(data));
    } else if (data.accountType === "ADMIN") {
      dispatch(loginAdminLocalSuccess(data));
    }
  }
};

export const verifyAdminAsync = (data) => async (dispatch) => {
  dispatch(verifyAdmin());
  try {

    const response = await axiosInstance.post("AdminConroller/VerifyOtp", data);
    console.log('response while otp...', response);
    if (response?.data?.status === 200 || 201) {
      const token = await response.headers["token"];
      const Refreshtoken = await response.headers["refreshtoken"];

      dispatch(verifyAdminSuccess(response.data));
      sessionStorage.setItem(
        "userLoggedDetails",
        JSON.stringify(response.data)
      );
      if (response.data.accountType == 'admin') {
        sessionStorage.removeItem('MaUser')
      }
      sessionStorage.setItem("userLoggedToken", JSON.stringify(token));
      sessionStorage.setItem("refreshToken", JSON.stringify(Refreshtoken));
      toast.success("Login Successful!!");
      return response;
    } else {

      dispatch(verifyAdminFailed());
      toast.error(
        response?.data?.message ||
        response?.data?.error ||
        "Verification failed."
      );
    }
  } catch (error) {
    dispatch(verifyAdminFailed());
    toast.error(
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "An error occurred."
    );
    console.log('error', error);

    return error;
  }
};

export const logoutUserAsync = (data) => async (dispatch) => {
  if (!data?.isSwitch) {
    dispatch(logout());
  }
  try {
    const response = await axiosInstance.post(
      "/AdminConroller/LogoutUser",
      data
    );
    if (!data?.isSwitch) {
      if (response.status === 200) {
        dispatch(logoutSuccess(response.status));
        // localStorage.clear();
        return response;
      } else {
        dispatch(logoutFailed());
        Swal.fire("Sorry", " Unable to Logout", "error");
      }
    }
  } catch (err) {
    dispatch(logoutFailed());
    // Swal.fire("Sorry", " Unable to Logout", "error");
  }
};

export const refreshUserAsync = (data) => async (dispatch) => {
  try {
    dispatch(setLoading()); // Start loading
    const response = await axiosInstance.post(
      "/upload/updateExpireToken",
      data
    );
    if (response.status === 200) {
      const token = response.data.token.token;
      const updateuserdata = response.data.token.updateuserdata;
      sessionStorage.setItem("userLoggedToken", JSON.stringify(token));
      sessionStorage.setItem(
        "userLoggedDetails",
        JSON.stringify(updateuserdata)
      );
      dispatch(refreshSuccess(updateuserdata)); // Dispatch success action
      console.log("Token api", response);
      // window.location.reload();
    } else {
      dispatch(logoutFailed());
      Swal.fire("Failed");
    }
  } catch (err) {
    dispatch(refreshFailed()); // Handle error
    console.error("Error during refresh:", err);
  }
};

export const ResendEamilAsync = (data) => async (dispatch) => {
  dispatch(ResendEmail());
  try {
    const response = await axiosInstance.post(
      "/upload/resendMailForIsVerifiedTrue",
      data
    );
    if (response) {
      console.log("repo", response);
      dispatch(ResendSuccessfully(response.data));
      return response.data;
    }
  } catch (error) {
    console.log(error);
    dispatch(ResendError());
  }
};

export const renewToken = (refreshToken, accessToken,fromWebPortal) => async (dispatch) => {
  dispatch(ResendEmail());
  try {
    console.log('fromWebPortal api',fromWebPortal);
    
    let resp;
    if(fromWebPortal){
       resp = await axiosInstanceWebPortal.post("/upload/renewToken", {
        refreshToken,
        accessToken,
      });
    }else{
      resp = await axiosInstance.post("/upload/renewToken", {
        refreshToken,
        accessToken,
      });
    }
   
    dispatch(ResendSuccessfully(resp.data));
    if (resp.status === 200 || resp.status === 201) {
      const newToken = resp.headers["token"];
      const newRefreshToken = resp.headers["refreshtoken"];
      // Store new tokens in AsyncStorage
      sessionStorage.setItem("userLoggedToken", JSON.stringify(newToken));
      sessionStorage.setItem("refreshToken", JSON.stringify(newRefreshToken));
      console.log(
        "newToken:???????????????///////////////////////", newToken
      );
      let loggesInUser = JSON.parse(sessionStorage.getItem("userLoggedDetails"));
      Socket.socketInit(loggesInUser?.userId, dispatch);
      return newToken;
    }
  } catch (error) {

    if (error.response?.data?.error?.includes('You were logged out due to a new device login from another device')) {
      forceLogout(
        error.response?.data?.error,
        null,
      );
    }

    if (
      error.response?.data?.message?.includes('Refresh token and access token are required') ||
      error.response?.data?.error?.includes('Refresh token and access token are required')
    ) {
      Swal.fire({
        title: 'Session Expired',
        text: 'Your session has expired. Please login again.',
        icon: 'warning',
        confirmButtonText: 'OK',
        confirmButtonColor: '#1976d2',
        allowOutsideClick: false,
      }).then(() => {
        sessionStorage.clear();
        dispatch(logoutSuccess());
      });
    }

    if (error.response?.data?.error?.includes('Both tokens have expired. Please log in again.')) {
      Swal.fire({
        title: 'Session Expired',
        text: 'Your session has expired. Please login again.',
        icon: 'warning',
        confirmButtonText: 'OK',
        confirmButtonColor: '#1976d2',
        allowOutsideClick: false,
      }).then(() => {
        sessionStorage.clear();
        dispatch(logoutSuccess());
      });
    }

    dispatch(ResendError());
    console.error(
      "Error renewing token:???????????????///////////////////////",
      error
    );
  }
};



export const DeleteAccountAsync = (data) => async (dispatch) => {
  dispatch(DeleteAccount());
  try {
    const response = await axiosInstanceWebPortal.post(
      "/upload/DeleteAccountConfirm",
      data,
      { _skipRetry: true }
    );
    if (response) {
      dispatch(DeleteAccountSuccess(response.status));
       toast.success(response?.data?.resultModel);
    }
    return response;
  } catch (err) {
    dispatch(DeleteAccountError());
    if (err?.response?.status === 401) {
      return err.response;
    }
    return err;
  }
};


export const {
  login,
  loginMasterSuccess,
  loginAdminSuccess,
  loginAdminLocalSuccess,
  verifyAdmin,
  verifyAdminSuccess,
  verifyAdminFailed,
  loginFailed,
  logout,
  emptyAuthState,
  logoutSuccess,
  logoutFailed,
  recognizeAccountType,
  LoginSpecial,
  LoginSpecialSuccess,
  LoginSpecialFailed,
  GetStatics,
  GetStaticsSuccess,
  GetStaticsFailed,
  ResendEmail,
  ResendSuccessfully,
  ResendError,
  updateidebarStatus,
  refreshSuccess,
  refreshFailed,
  setLoading,
  UpdateSessionAlert,
  ToggleSessionAlert,
  UploadingProgress,
  GetUniqueId,
  GetUniqueIdSuccess,
  GetUniqueIdFailed,
  setOfflineStatus,
  setServerDown,
  VerifyCredentials,
  VerifyCredentialsSuccess,
  VerifyCredentialsError,
  DeleteAccount,
  DeleteAccountSuccess,
  DeleteAccountError,
} = authSlice.actions;

export default authSlice.reducer;
